import {useRef, useContext, useCallback } from 'react'
import { AlertDialog, AlertDialogBody, AlertDialogFooter, AlertDialogHeader, AlertDialogContent, AlertDialogOverlay, Button } from '@chakra-ui/react'
import { AdsContext } from '../../store/ads'
import { UserContext } from '../../store/user'

const DeleteVariation = ({isOpen, onClose}) => {
	const cancelRef = useRef()
	const { state: adsState, dispatch: adsDispatch, saveCampaign } = useContext(AdsContext)
	const { state: userState } = useContext(UserContext)

	const deleteVariation = useCallback(async () => {
		const variations = adsState.campaign.variations.filter((_, i) => i !== adsState.selectedVariation)
        adsState.campaign.variations = variations
        adsDispatch({ type: "SET_CAMPAIGN", value: adsState.campaign })
		adsDispatch({ type: "SET_SELECTED_VARIATION", value: null });
		if (userState.token) {
			await saveCampaign(adsState.campaign.id, variations)
		}
	}, [adsState.campaign, adsState.selectedVariation])
	return (
		<AlertDialog isOpen={isOpen} leastDestructiveRef={cancelRef} onClose={() =>{ adsDispatch({ type: "SET_SELECTED_VARIATION", value: null }); onClose()}} isCentered>
			<AlertDialogOverlay>
				<AlertDialogContent>
					<AlertDialogHeader fontSize="lg" fontWeight="bold">Delete Variation</AlertDialogHeader>
					<AlertDialogBody> Are you sure? You can't undo this action afterwards.</AlertDialogBody>
					<AlertDialogFooter>
						<Button ref={cancelRef} onClick={onClose}>Cancel</Button>
						<Button colorScheme="red" onClick={() => {deleteVariation(); onClose()}} ml={3}>Delete</Button>
					</AlertDialogFooter>
				</AlertDialogContent>
			</AlertDialogOverlay>
		</AlertDialog>
	)
}
export default DeleteVariation